import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Američki nogomet",
    Baseball: "Bejzbol",
    Basketball: "Košarka",
    Boxing: "Boks",
    Chess: "Šah",
    Cricket: "Kriket",
    Darts: "Pikado",
    Entertainment: "Zabava",
    "E-Sports": "E-sport",
    Football: "Nogomet",
    "Formula 1": "Formula 1",
    "Gaelic Football": "Galski Nogomet",
    "Generic Sport": "Generički Sport",
    Golf: "Golf",
    "Greyhound Racing": "Utrke Hrtova",
    Handball: "Rukomet",
    "Ice Hockey": "Hokej na ledu",
    IndyCar: "IndyCar",
    MMA: "Mješovite Borilačke Vještine",
    Nascar: "Nascar",
    Politics: "Politika",
    "Rugby League": "Ragbi Liga",
    "Rugby Union": "Ragbi Union",
    Snooker: "Snooker",
    "Table Tennis": "Stolni Tenis",
    Tennis: "Tenis",
    "Virtual Football": "Virtualni Nogomet",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} će pobijediti",
    WinFirstRound: "{name} će dobiti prvu rundu",
    FirstTouchdown: "{name} će prvi poentirati polaganjem",
    FirstTry: "{name} će prvi poentirati esejom",
    TotalGoals: "{name} zbroj golova",
    TotalRuns: "{name} zbroj runova",
    TotalPoints: "{name} zbroj poena",
    TopBatsman: "{name} će biti najbolji udarač",
    TopBowler: "{name} će biti najbolji bacač",
    FirstScore: "{name} će prvi zabiti"
  },
  PromoTexts: {
    Pick: "Postavite svoje oklade",
    Bet: "Uplata",
    Pays: "Isplata"
  },
  DateTimeTexts: {
    Today: "Danas",
    Tomorrow: "Sutra",
    Live: "Uživo"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Postavite svoje oklade",
    Return: "Isplata",
    Stake: "Uplata",
    Draw: "X"
  },
  H2HTexts: {
    // general
    "Per match": "po utakmici",
    H2H: "H2H",
    W: "P",
    D: "N",
    L: "I",
    T: "N",

    // soccer
    goals_scored: "Dati golovi",
    shots: "Udarci",
    shots_on_target: "Udarci u okvir gola",
    ball_possession: "Posjed lopte",
    goals_conceded: "Primljeni golovi",

    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing Stats",
    rushing_yards_per_game: "Rushing Yards",
    rushing_touchdowns: "Rushing Touchdowns (total)",
    rushing_percentage: "Rushing %",
    passing_stats: "Passing Stats",
    passing_yards_per_game: "Passing Yards",
    passing_touchdowns: "Passing Touchdowns (total)",
    passing_percentage: "Passing %"
  }
};
